import { render } from "./CreateGameModal.vue?vue&type=template&id=30ddb4ac"
import script from "./CreateGameModal.vue?vue&type=script&lang=js"
export * from "./CreateGameModal.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__